// import "./update.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import Select from "react-select";
// import { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { roleInputs } from "../../formSource";
// import { serverUrl } from "../../temp";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const statusOptions = [
//   { value: 1, label: "Active" },
//   { value: 0, label: "Inactive" },
// ];

// const RoleUpdate = ({ title }) => {
//   const location = useLocation();
//   const roleId = location.pathname.split("/").pop(); // simplest solution\\
//   console.log("roles", roleId);
//   const [selectedSubject, setSelectedSubject] = useState([]);
//   const [allSubjects, setAllSubjects] = useState([]);
//   const [filteredSubjects, setFilteredSubjects] = useState([]);
//   const [selectedStatus, setSelectedStatus] = useState(null);
//   const [inputValues, setInputValues] = useState({});
//   const center_id = localStorage.getItem("center_id");
//   const [token] = useState(localStorage.getItem("token"));
//   const navigate = useNavigate();

//   const redirectToLogin = () => {
//     alert("Please login first.");
//     window.location.href = "/";
//   };

//   useEffect(() => {
//     const fetchRole = async () => {
//       try {
//         const res = await fetch(`${serverUrl}/role/${roleId}`);
//         const data = await res.json();
//         const status = data.data.status;
//         setSelectedStatus(
//           status === 1
//             ? { value: 1, label: "Active" }
//             : { value: 0, label: "Inactive" }
//         );
//         const snames = data.data.screen_names.split(",");
//         const sid = data.data.screen_id.split(",");
//         const preSelected = sid.map((id, i) => ({
//           value: parseInt(id),
//           label: snames[i],
//         }));
//         setSelectedSubject(preSelected);
//         setInputValues(data.data);
//       } catch (err) {
//         console.error(err);
//       }
//     };

//     if (roleId) {
//       fetchRole();
//     }
//   }, [roleId]);

//   useEffect(() => {
//     const fetchSubjects = async () => {
//       try {
//         const res = await fetch(`${serverUrl}/rscreen_ids`);
//         const data = await res.json();
//         const options = data.data.map((item) => ({
//           value: item.id,
//           label: item.name,
//         }));
//         setAllSubjects(options);
//       } catch (err) {
//         console.error(err);
//       }
//     };

//     fetchSubjects();
//   }, []);

//   useEffect(() => {
//     // Filter out selected subjects from all subjects
//     const selectedIds = selectedSubject.map((item) => item.value);
//     const filtered = allSubjects.filter(
//       (option) => !selectedIds.includes(option.value)
//     );
//     setFilteredSubjects(filtered);
//   }, [allSubjects, selectedSubject]);

//   const handleInputChange = (e) => {
//     setInputValues({
//       ...inputValues,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleStatusSelectChange = (selectedOption) => {
//     setSelectedStatus(selectedOption);
//     setInputValues({
//       ...inputValues,
//       status: selectedOption.value,
//     });
//   };

//   const handleSubjectSelectChange = (selectedOptions) => {
//     setSelectedSubject(selectedOptions || []);
//   };
//   useEffect(() => {
//     if (allSubjects.length === 0) return;

//     const selectedIds = selectedSubject.map((item) => item.value);
//     const filtered = allSubjects.filter(
//       (option) => !selectedIds.includes(option.value)
//     );
//     setFilteredSubjects(filtered);
//   }, [allSubjects, selectedSubject]);

//   const handleUpdate = async (e) => {
//     e.preventDefault();
//     const formData = new FormData();
//     const screenIds = selectedSubject.map((opt) => opt.value);
//     // formData.append("center_id", localStorage.getItem("center_id"));
//     formData.append("name", inputValues.name);
//     formData.append("screen_id", screenIds);
//     formData.append(
//       "status",
//       parseInt(inputValues.status || selectedStatus.value)
//     );

//     try {
//       const res = await fetch(`${serverUrl}/upd_role/${roleId}`, {
//         method: "PUT",
//         body: formData,
//       });
//       const data = await res.json();
//       toast.success("Role updated successfully!");
//       setTimeout(() => {
//         navigate("/role");
//       }, 1000);
//     } catch (err) {
//       toast.error("Failed to update role.");
//       console.error(err);
//     }
//   };

//   return (
//     <>
//       <ToastContainer />
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="update">
//           <Sidebar />
//           <div className="updateContainer">
//             <Navbar />
//             <div className="top">
//               <h1>{title}</h1>
//             </div>
//             <div className="bottom">
//               <div className="right">
//                 <form onSubmit={handleUpdate}>
//                   {roleInputs.map((input) => (
//                     <div className="formInput" key={input.id}>
//                       <label>{input.label}</label>
//                       {input.fieldName === "screen_id" ? (
//                         <Select
//                           options={filteredSubjects}
//                           name={input.fieldName}
//                           isMulti
//                           value={selectedSubject}
//                           onChange={handleSubjectSelectChange}
//                           required
//                         />
//                       ) : input.fieldName === "status" ? (
//                         <Select
//                           options={statusOptions}
//                           name={input.fieldName}
//                           value={selectedStatus}
//                           onChange={handleStatusSelectChange}
//                           required
//                         />
//                       ) : (
//                         <input
//                           type={input.type}
//                           placeholder={input.placeholder}
//                           name={input.fieldName}
//                           value={inputValues[input.fieldName] || ""}
//                           onChange={handleInputChange}
//                           required
//                         />
//                       )}
//                     </div>
//                   ))}
//                   <div className="formUpdate" style={{ clear: "both" }}>
//                     <button type="submit" style={{ float: "right" }}>
//                       Update
//                     </button>
//                   </div>
//                   <div>
//                     <button
//                       type="button"
//                       style={{ float: "right" }}
//                       onClick={() => navigate(`/role`)}
//                     >
//                       Cancel
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default RoleUpdate;
import React, { useState, useEffect } from "react";
import Select from "react-select";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { roleInputs } from "../../formSource";
import { useLocation, useNavigate } from "react-router-dom";
import { serverUrl } from "../../temp";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import "./update.scss";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const statusOptions = [
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];

const RoleUpdate = ({ title }) => {
  const location = useLocation();
  const roleId = location.pathname.split("/").pop();
  const navigate = useNavigate();

  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [allSubjects, setAllSubjects] = useState([]);
  const [filteredSubjects, setFilteredSubjects] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [inputValues, setInputValues] = useState({});
  const [token] = useState(localStorage.getItem("token"));

  const redirectToLogin = () => {
    alert("Please login first to access this page");
    window.location.href = "/";
  };

  useEffect(() => {
    const fetchRole = async () => {
      try {
        const response = await fetch(`${serverUrl}/role/${roleId}`);
        if (!response.ok) throw new Error("Failed to fetch role data");
        const data = await response.json();
        
        const status = data.data.status;
        setSelectedStatus(
          status === 1
            ? { value: 1, label: "Active" }
            : { value: 0, label: "Inactive" }
        );

        const screenNames = data.data.screen_names.split(",");
        const screenIds = data.data.screen_id.split(",");
        const preSelected = screenIds.map((id, i) => ({
          value: parseInt(id),
          label: screenNames[i],
        }));

        setSelectedSubjects(preSelected);
        setInputValues(data.data);
      } catch (error) {
        console.error(error);
        toast.error("Failed to fetch role data");
      }
    };

    if (roleId) fetchRole();
  }, [roleId]);

  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        const response = await fetch(`${serverUrl}/rscreen_ids`);
        if (!response.ok) throw new Error("Failed to fetch screens");
        const data = await response.json();
        const options = data.data.map(item => ({
          value: item.id,
          label: item.name
        }));
        setAllSubjects(options);
      } catch (error) {
        console.error(error);
        toast.error("Failed to fetch screen options");
      }
    };

    fetchSubjects();
  }, []);

  useEffect(() => {
    if (allSubjects.length === 0) return;
    
    const selectedIds = selectedSubjects.map(item => item.value);
    const filtered = allSubjects.filter(
      option => !selectedIds.includes(option.value)
    );
    setFilteredSubjects(filtered);
  }, [allSubjects, selectedSubjects]);

  const handleInputChange = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleStatusChange = (selectedOption) => {
    setSelectedStatus(selectedOption);
    setInputValues({
      ...inputValues,
      status: selectedOption.value,
    });
  };

  const handleSubjectsChange = (selectedOptions) => {
    setSelectedSubjects(selectedOptions || []);
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    
    const formData = new FormData();
    const screenIds = selectedSubjects.map(opt => opt.value);
    
    formData.append("name", inputValues.name);
    formData.append("screen_id", screenIds);
    formData.append("status", inputValues.status || selectedStatus.value);

    try {
      const response = await fetch(`${serverUrl}/upd_role/${roleId}`, {
        method: "PUT",
        body: formData,
      });

      const data = await response.json();

      if (data.code >= 400) {
        if (typeof data.message === "object") {
          Object.entries(data.message).forEach(([field, errors]) => {
            errors.forEach(errMsg => toast.error(`${field}: ${errMsg}`));
          });
        } else {
          toast.error(data.message || "Update failed");
        }
      } else {
        toast.success("Role updated successfully!");
        setTimeout(() => navigate("/role"), 1000);
      }
    } catch (error) {
      console.error(error);
      toast.error("Network error. Please try again.");
    }
  };

  return (
    <ThemeProvider theme={theme}>
      {!token && redirectToLogin()}
      {token && (
        <div className="update">
          <Sidebar />
          <div className="updateContainer">
            <Navbar />
            <div className="contentWrapper">
              <Card className="formCard">
                <CardContent className="cardContent">
                  <Typography variant="h5" component="h2" gutterBottom className="formTitle">
                    {title}
                  </Typography>

                  <form onSubmit={handleUpdate} className="responsiveForm">
                    <Grid container spacing={2}>
                      {roleInputs.map((input) => (
                        <Grid item xs={12} sm={6} key={input.id} className="formGridItem">
                          <div className="formInput">
                            <label>{input.label}</label>
                            {input.fieldName === "screen_id" ? (
                              <Select
                                options={filteredSubjects}
                                isMulti
                                value={selectedSubjects}
                                onChange={handleSubjectsChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: '46px',
                                    borderColor: '#e2e8f0',
                                    '&:hover': {
                                      borderColor: '#cbd5e0'
                                    }
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: '2px 8px'
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0'
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '44px'
                                  })
                                }}
                              />
                            ) : input.fieldName === "status" ? (
                              <Select
                                options={statusOptions}
                                value={selectedStatus}
                                onChange={handleStatusChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: '46px',
                                    borderColor: '#e2e8f0',
                                    '&:hover': {
                                      borderColor: '#cbd5e0'
                                    }
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: '2px 8px'
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0'
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '44px'
                                  })
                                }}
                              />
                            ) : (
                              <input
                                type={input.type}
                                placeholder={input.placeholder}
                                name={input.fieldName}
                                value={inputValues[input.fieldName] || ""}
                                onChange={handleInputChange}
                                required
                              />
                            )}
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                    <Box sx={{ 
                      display: "flex", 
                      justifyContent: "center", 
                      gap: 3, 
                      mt: 4, 
                      pb: 2 
                    }}>
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => navigate("/role")}
                        sx={{ minWidth: '120px', height: '42px' }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: '150px', height: '42px' }}
                      >
                        Update Role
                      </Button>
                    </Box>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </ThemeProvider>
  );
};

export default RoleUpdate;